'use client';

import {
    Align,
    Column,
    Columns,
    Container,
    Row,
    Rows,
    Section,
    Text,
    TextLevels,
    Title,
    TitleLevels,
    TrilogyColor,
} from '@bytel/trilogy-react';

import { useMediaQuery } from '@hooks/use-media-query';

type HeroProps = {
    title: string;
    subtitle: string;
    backgroundDesktopUrl?: string;
    backgroundMobileUrl?: string;
};

export function Hero({ title, subtitle, backgroundDesktopUrl, backgroundMobileUrl }: Readonly<HeroProps>) {
    const isMobile = useMediaQuery('(max-width: 767px)');
    const backgroundSrc = isMobile ? backgroundMobileUrl : backgroundDesktopUrl;

    return (
        <Section backgroundSrc={backgroundSrc} backgroundColor={backgroundSrc ? undefined : TrilogyColor.MAIN}>
            <Container>
                <Columns verticalAlign={Align.CENTER} className='hero-content'>
                    <Column size={6} className='hero-text'>
                        <Rows>
                            <Row>
                                <Title
                                    markup='h1'
                                    inverted
                                    level={TitleLevels.ONE}
                                    className='has-text-centered-mobile'
                                >
                                    {title}
                                </Title>
                            </Row>
                            <Row>
                                <Text level={TextLevels.ONE} inverted className='has-text-centered-mobile subtitle'>
                                    {subtitle}
                                </Text>
                            </Row>
                        </Rows>
                    </Column>
                </Columns>
            </Container>
        </Section>
    );
}
